(() => {
  if (customElements.get('collection-promo-title')) return;

  customElements.define('collection-promo-title', class extends HTMLElement {
    connectedCallback() {
      this.titleElement = this.querySelector('.collection-promo-grid__title');
      if (!this.titleElement) return;
      this.scheduleFit = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.resizeObserver = new ResizeObserver(this.scheduleFit);
      this.resizeObserver.observe(this);
      this.textObserver = new MutationObserver(this.scheduleFit);
      this.textObserver.observe(this.titleElement, { childList: true, characterData: true, subtree: true });
      window.addEventListener('resize', this.scheduleFit);
      document.fonts?.addEventListener('loadingdone', this.scheduleFit);
      document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleFit(); });
      this.scheduleFit();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.textObserver?.disconnect();
      window.removeEventListener('resize', this.scheduleFit);
      document.fonts?.removeEventListener('loadingdone', this.scheduleFit);
    }

    fit() {
      const title = this.titleElement;
      title.style.removeProperty('font-size');
      if (!this.clientWidth || !this.clientHeight) return;
      const style = getComputedStyle(this);
      const height = this.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      const width = this.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      if (height <= 0 || width <= 0) return;
      const fits = () => title.getBoundingClientRect().height <= height && title.scrollWidth <= width + 1;
      if (fits()) return;
      // Use the editor's font size as a maximum, shrinking only overflowing titles.
      let high = parseFloat(getComputedStyle(title).fontSize);
      let low = 1;
      while (high - low > 0.25) {
        const middle = (low + high) / 2;
        title.style.fontSize = `${middle}px`;
        if (fits()) low = middle;
        else high = middle;
      }
      title.style.fontSize = `${low}px`;
    }
  });
})();
